export const CAL_COM_API_URL = 'https://api.cal.com/v2';
